export const ActionTypes = {
  GET_USER_AUTH_DATA: 'services/auth/get_user_auth_data',
  SET_USER_AUTH_DATA: 'services/auth/set_user_auth_data',
  GET_FACTORY_LABELS_DETAILS: 'services/auth/get_factory_labels_detail',
  SET_FACTORY_LABELS_DETAILS: 'services/auth/set_factory_labels_detail',
  FETCH_ACTIVE_PACKAGE: 'services/auth/fetch_active_package',
  SET_ACTIVE_PACKAGE: 'services/auth/set_active_package',
  GET_REFRESH_TOKEN: 'services/auth/get_refresh_token',
  SET_LOADER_STATUS: 'services/auth/set_loader_status',
};

const getUserAuthData = () => ({
  type: ActionTypes.GET_USER_AUTH_DATA,
});

const setUserAuthData = ({ userAuthData }) => ({
  userAuthData,
  type: ActionTypes.SET_USER_AUTH_DATA,
});

const getFactoryLabelsDetail = ({ userID }) => ({
  userID,
  type: ActionTypes.GET_FACTORY_LABELS_DETAILS,
});

const setFactoryLabelsDetail = ({ factoryLabelsDetail }) => ({
  factoryLabelsDetail,
  type: ActionTypes.SET_FACTORY_LABELS_DETAILS,
});

const fetchActivePackageDetail = () => ({
  type: ActionTypes.FETCH_ACTIVE_PACKAGE,
});

const setActivePackageDetail = ({ activePackageData }) => ({
  activePackageData,
  type: ActionTypes.SET_ACTIVE_PACKAGE,
});

const getRefreshToken = () => ({
  type: ActionTypes.GET_REFRESH_TOKEN,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  getUserAuthData,
  setUserAuthData,
  getFactoryLabelsDetail,
  setFactoryLabelsDetail,
  fetchActivePackageDetail,
  setActivePackageDetail,
  getRefreshToken,
  setLoader,
};
